import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {TabsModule} from '../../components/tabs/tabs.module';
import {CommonComponentsModule} from '../../common-components.module';
import {DatetimeModule} from '../../components/datetime/datetime.module';
import {ClassifiedsMccComponent} from './classifieds-mcc.component';
import {ClassifiedsMccFilterComponent} from '../../components/classifieds-mcc-filter/classifieds-mcc-filter.component';
import {ClassifiedsMccService} from '../../services/classifieds-mcc.service';
import {ClassifiedsMccListComponent} from './classifieds-mcc-list/classifieds-mcc-list.component';
import {ClassifiedsMccModalComponent} from './classifieds-mcc-modal/classifieds-mcc-modal.component';
import {AngularMaterialImportModule} from '../../components/angular-material-import-module/angular-material-import.module';
import {NoticesModule} from '../notices/notices.module';
import {AngularMultiSelectModule} from '../../components/angular2-multiselect-dropdown/multiselect.component';
import {UtilsModule} from '../../modules/utils/utils.module';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        TabsModule,
        RouterModule,
        CommonComponentsModule,
        DatetimeModule,
        AngularMaterialImportModule,
        NoticesModule,
        AngularMultiSelectModule,
        UtilsModule
    ],
    declarations: [
        ClassifiedsMccComponent,
        ClassifiedsMccFilterComponent,
        ClassifiedsMccListComponent,
        ClassifiedsMccModalComponent
    ],
    providers: [
        ClassifiedsMccService
    ]
})
export class ClassifiedsMccModule {
}




// WEBPACK FOOTER //
// /app/src/app/views/classifieds-mcc/classifieds-mcc.module.ts